<template>
  <el-container class="layout">
    <div class="asside" :style="fixed ? 'width: 60px' : 'width: 240px'">
      <left-menu @fixed="fixFn"></left-menu>
      <!-- <div class="wrapper-logo" @click="pageToHome">
        <img src="@/assets/img/layout/logo.png" />
      </div>
      <Sidebar></Sidebar> -->
      <!-- <el-scrollbar wrapClass="scrollbar-wrapper">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>导航一</span>
            </template>
            <el-menu-item-group>
              <template slot="title">分组一</template>
              <el-menu-item index="1-1">选项1</el-menu-item>
              <el-menu-item index="1-2">选项2</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group title="分组2">
              <el-menu-item index="1-3">选项3</el-menu-item>
            </el-menu-item-group>
            <el-submenu index="1-4">
              <template slot="title">选项4</template>
              <el-menu-item index="1-4-1">选项1</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-menu-item index="4">
            <i class="el-icon-setting"></i>
            <span slot="title">导航四</span>
          </el-menu-item>
        </el-menu>
      </el-scrollbar> -->
    </div>
    <div class="layout-content">
      <network-component></network-component>
      <el-container class="container">
        <el-header class="header" height="70px">
          <navbar></navbar>
        </el-header>
        <el-container class="layout-body">
          <el-main class="main">
            <!-- <el-main class="content"></el-main> -->
            <transition name="fade" mode="out-in">
              <!-- :key="$route.path" -->
              <!-- {{ $route.path }}
        {{ $route.fullPath }} -->
              <router-view />
            </transition>
          </el-main>
          <!-- 新功能引导 -->
          <div
            v-if="showNewFeatureGuide"
            class="new-feature-guide"
            @click="handleOpenServiceSubscriptionGuide"
          >
            <div class="guide-title">
              <div class="title-text">新功能上线</div>
              <div class="title-actions">
                <div class="title-tag">NEW</div>
                <i
                  class="guide-close el-icon-close"
                  title="关闭"
                  @click.stop="handleCloseNewFeatureGuide"
                ></i>
              </div>
            </div>
            <div class="guide-item">
              <el-image
                fit="widthFix"
                class="guide-item-cover"
                src="https://image.renrenjiang.cn/home/icon_new_guide_01.png"
              ></el-image>
            </div>
            <div class="guide-item">
              <el-image
                fit="widthFix"
                class="guide-item-cover"
                src="https://image.renrenjiang.cn/home/icon_new_guide_02.png"
              ></el-image>
            </div>
            <div class="guide-gap"></div>
            <div class="guide-contact">
              <div class="guide-contact-title">搭建</div>
              <div class="guide-contact-key">“获客”-“私域”-“转化”</div>
              <div class="guide-contact-title">一体化解决方案</div>
              <el-button size="small" type="primary" class="guide-contact-btn">
                联系客户经理定制方案
              </el-button>
            </div>
          </div>
          <!-- v-if="drawer" -->
          <div class="right-layout" :class="{ 'right-layout-active': drawer }">
            <div class="dialog-head">
              <div class="dialog-head-title">上传图片{{ drawer }}</div>
              <div class="dialog-head-close" @click="closeDrawer"></div>
            </div>
          </div>
        </el-container>
      </el-container>
    </div>

    <!-- <template v-if="newUploads.length">
      <div v-show="showBall" class="process-ball" @click="showBall = false">
        <el-badge :value="newUploads.length" class="item">
          <img src="../../assets/img/layout/icon_upload.png" />
        </el-badge>
      </div>

      <div
        v-show="!showBall"
        class="process-dialog"
        :class="{ 'process-dialog-active': !showBall }"
      >
        <div class="dialog-head">
          <div class="dialog-head-title">上传文件</div>
          <div class="dialog-head-close" @click="showBall = true"></div>
        </div>
        <div class="dialog-body padding">
          <el-table header-row-class-name="header-row" :data="newUploads">
            <el-table-column prop="courseInfo" label="资料">
              <template slot-scope="scope">
                <div class="file-item">
                  <el-image
                    class="file-item-cover"
                    fit="contain"
                    :src="
                      'https://image.renrenjiang.cn/teacher_center/website/file/icon_file_' +
                      scope.row.fileFix +
                      '.png'
                    "
                  ></el-image>
                  <div class="file-item-title">
                    {{ scope.row.activity.title }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="大小">
              <template slot-scope="scope">
                <el-progress
                  :show-text="false"
                  :percentage="scope.row.schedule - 0"
                ></el-progress>
                <div class="process-line">
                  <div>{{ scope.row.fileSize }} M</div>
                  <div>
                    {{
                      scope.row.status === 1
                        ? scope.row.schedule + "%"
                        : scope.row.status === 0
                        ? "上传失败"
                        : scope.row.status === 2
                        ? "转码中..."
                        : scope.row.status === 3
                        ? "成功"
                        : scope.row.status === 5
                        ? "成功"
                        : "失败"
                    }}
                    <el-button
                      v-if="scope.row.status === 0"
                      :loading="loading"
                      @click="retryUpload(scope.row.activity.id)"
                    >
                      续传
                    </el-button>
                    <el-button
                      v-if="scope.row.status === 4"
                      @click="restartUpload(scope.row.activity.id)"
                    >
                      重传
                    </el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="操作"
              align="right"
              width="70px"
            >
              <template slot-scope="scope">
                <div>
                  <el-button
                    type="text"
                    size="small"
                    @click.native.prevent="deleteUpload(scope.row.activity.id)"
                  >
                    {{ scope.row.schedule == 100 ? "消 除" : "取 消" }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </template> -->

    <!-- 讲师助手 -->
    <!-- <div
      v-if="user && user.id === 21217432"
      class="float-customer"
      :class="{ expend: helpExpend, anim: helpAnim, hidden: helpWindow }"
    >
      <div class="float-customer-ip"></div>
      <div class="float-customer-questions">
        <div class="question-block">
          <div class="question-title">为你推荐内容</div>
          <div class="question-subtitle">当前位于【课程管理-视频课】</div>
          <div class="question-list">
            <div v-for="i in 6" v-bind:key="i" class="question-item">
              如何识别行业市场的“搜索热度”？
            </div>
          </div>
        </div>
        <div @click="closeCustomerExpend" class="float-customer-close"></div>
      </div>
      <div @click="openCustomerWindow" class="float-customer-btn">讲师助手</div>
    </div> -->

    <!-- 讲师助手窗口 -->
    <div class="customer-window" :class="{ active: helpWindow }">
      <div class="customer-window-head">
        <div @click="helpSearch = true" class="customer-window-search">
          <el-image
            class="search-icon"
            src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_win_search.png"
          ></el-image>
          <div class="search-text">有问题？搜一搜</div>
        </div>
        <div class="customer-window-keywords">
          <div class="keyword-item">讲师资质</div>
          <div class="keyword-item">课程审核</div>
          <div class="keyword-item">资金提现</div>
          <div class="keyword-item">直播挂载</div>
        </div>
      </div>
      <div class="customer-window-body">
        <div class="window-body-title">
          <div class="title-text">自主工具</div>
        </div>
        <div class="window-body-quicks">
          <div class="quick-item">
            <el-image
              class="quick-item-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_tool_teacher.png"
            ></el-image>
            <div class="quick-item-text">讲师资质</div>
          </div>
          <div class="quick-item">
            <el-image
              class="quick-item-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_tool_course.png"
            ></el-image>
            <div class="quick-item-text">课程审核</div>
          </div>
          <div class="quick-item">
            <el-image
              class="quick-item-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_tool_cash.png"
            ></el-image>
            <div class="quick-item-text">资金提现</div>
          </div>
          <div class="quick-item">
            <el-image
              class="quick-item-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_tool_live.png"
            ></el-image>
            <div class="quick-item-text">直播挂课</div>
          </div>
        </div>
        <div class="window-body-title">
          <div class="title-text">猜你想问</div>
          <div class="title-btn">
            <div class="title-btn-text">换一换</div>
            <el-image
              class="title-btn-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_qa_refresh.png"
            ></el-image>
          </div>
        </div>
        <div class="window-body-questions">
          <div class="question-item">
            <el-image
              class="question-item-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_qa_icon.png"
            ></el-image>
            <div class="question-item-content">
              【玩转搜索】如何做好商品的主图优化如何做好商品的主图优化？
            </div>
            <el-image
              class="question-item-arrow"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_preview_arrow.png"
            ></el-image>
          </div>
        </div>
      </div>
      <div class="customer-window-search-block" :class="{ active: helpSearch }">
        <div class="search-block">
          <div class="search-block-head">
            <el-input
              v-model="helpKeyword"
              class="search-block-input"
              placeholder="有问题？搜一搜"
              size="small"
            >
              <el-image
                slot="prefix"
                fit="contain"
                class="input-search-icon"
                src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_win_search.png"
              ></el-image>
            </el-input>
            <div @click="helpSearch = false" class="search-block-btn">取消</div>
          </div>
          <div class="search-block-body">
            <div class="search-block-title">
              <div class="title-text">搜索历史</div>
            </div>
            <div class="search-block-title">
              <div class="title-text">热门搜索</div>
            </div>
            <div class="search-block-hots">
              <div class="hot-item">
                <div class="hot-item-num">1</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">2</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">3</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">4</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">5</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">6</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">7</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">8</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="customer-window-floating">
        <div class="floating-block">
          <el-image
            class="floating-icon"
            src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_call_icon.png"
          ></el-image>
          <div class="floating-text">联系助手</div>
        </div>
      </div>
      <div class="customer-window-ip">
        <el-image
          class="window-ip-img"
          src="https://cdn-hz.renrenjiang.cn/teacher_center/douyin/icon_customer_window_ip.png"
        ></el-image>
        <div class="window-ip-text">您好，我是您的讲师助手</div>
      </div>
      <div @click="closeCustomerWindow" class="customer-window-close"></div>
    </div>

    <!--  行业案例  -->
    <el-dialog
      class="new-guide-dialog"
      :show-close="false"
      :visible.sync="showDemoDialog"
      width="1271px"
    >
      <div class="guide-wrapper">
        <div class="guide-left">
          <div class="title demo-title">多种场景，任你选择</div>
          <div
            class="item demo-item"
            :class="{ active: currentDemoIndex === 1 }"
            data-index="1"
            @click.stop="showDemo(1)"
          >
            <el-image
              class="item-icon demo-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title demo-item-title">付费进群</div>
          </div>
          <div
            class="item demo-item"
            :class="{ active: currentDemoIndex === 2 }"
            data-index="2"
            @click.stop="showDemo(2)"
          >
            <el-image
              class="item-icon demo-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title demo-item-title">打卡学习</div>
          </div>
          <div
            class="item demo-item"
            :class="{ active: currentDemoIndex === 3 }"
            data-index="3"
            @click.stop="showDemo(3)"
          >
            <el-image
              class="item-icon demo-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title demo-item-title">会员服务</div>
          </div>
          <div
            class="item demo-item"
            :class="{ active: currentDemoIndex === 4 }"
            data-index="4"
            @click.stop="showDemo(4)"
          >
            <el-image
              class="item-icon demo-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title demo-item-title">引流获客</div>
          </div>
          <div
            class="item demo-item"
            :class="{ active: currentDemoIndex === 5 }"
            data-index="5"
            @click.stop="showDemo(5)"
          >
            <el-image
              class="item-icon demo-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title demo-item-title">付费答疑</div>
          </div>
          <div
            class="item demo-item"
            :class="{ active: currentDemoIndex === 6 }"
            data-index="6"
            @click.stop="showDemo(6)"
          >
            <el-image
              class="item-icon demo-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title demo-item-title">信息分享</div>
          </div>
          <div
            class="item demo-item"
            :class="{ active: currentDemoIndex === 7 }"
            data-index="7"
            @click.stop="showDemo(7)"
          >
            <el-image
              class="item-icon demo-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title demo-item-title">私域直播</div>
          </div>
          <div
            class="item demo-item"
            :class="{ active: currentDemoIndex === 8 }"
            data-index="8"
            @click.stop="showDemo(8)"
          >
            <el-image
              class="item-icon demo-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title demo-item-title">班级运营</div>
          </div>
        </div>
        <div class="guide-right">
          <el-image class="guide-image" :src="demoImgPath"></el-image>
        </div>
        <div class="guide-btn">
          <div class="step-btn" @click.stop="addStepDemo">
            {{ demoBtnText }}
          </div>
          <i class="close-btn el-icon-error" @click.stop="closeDemoDialog"></i>
        </div>
      </div>
    </el-dialog>

    <!--  新手引导  -->
    <el-dialog
      class="new-guide-dialog"
      :show-close="false"
      :visible.sync="showGuideDialog"
      width="1271px"
    >
      <div class="guide-wrapper">
        <div class="guide-left">
          <div class="title">首次使用，必看功能</div>
          <div
            class="item"
            :class="{ active: currentGuideIndex === 1 }"
            data-index="1"
            @click.stop="showGuide(1)"
          >
            <el-image
              class="item-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title">创建星球</div>
            <div class="item-desc">创建一个星球，作为你的付费会员载体</div>
          </div>
          <div
            class="item"
            :class="[currentGuideIndex === 2 ? 'active' : '']"
            data-index="2"
            @click.stop="showGuide(2)"
          >
            <el-image
              class="item-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title">绑定微信群</div>
            <div class="item-desc">
              把微信群绑定到星球中，在成员购买星球后一键加群，实现会员转入私域
            </div>
          </div>
          <div
            class="item"
            :class="[currentGuideIndex === 3 ? 'active' : '']"
            data-index="3"
            @click.stop="showGuide(3)"
          >
            <el-image
              class="item-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title">渠道上架</div>
            <div class="item-desc">
              将星球商品一键上架到抖音/视频号/小红书/微信/网页等进行售卖推广
            </div>
          </div>
          <div
            class="item"
            :class="[currentGuideIndex === 4 ? 'active' : '']"
            data-index="4"
            @click.stop="showGuide(4)"
          >
            <el-image
              class="item-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title">会员运营</div>
            <div class="item-desc">
              持续为会员提供专属内容/课程/直播/答疑/打卡/作业/资料等长期价值
            </div>
          </div>
          <div
            class="item"
            :class="[currentGuideIndex === 5 ? 'active' : '']"
            data-index="5"
            @click.stop="showGuide(5)"
          >
            <el-image
              class="item-icon"
              src="https://image.renrenjiang.cn/jy_star/icons/three-gang.png"
            ></el-image>
            <div class="item-title">收益提现</div>
            <div class="item-desc">定期核对收益，完成收益结算和提现</div>
          </div>
        </div>
        <div class="guide-right">
          <el-image
            class="guide-image guide-image-margin"
            :src="guideImgPath"
          ></el-image>
        </div>
        <div class="guide-btn">
          <div
            v-if="currentGuideIndex < 6"
            class="step-btn"
            @click.stop="addStep"
          >
            {{ guideBtnText }}
          </div>
          <i
            class="close-btn el-icon-error"
            @click.stop="showGuideDialog = false"
          ></i>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :show-close="false"
      :visible.sync="showServeDialog"
      width="500px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="dialog-head">
        <div class="dialog-head-title">联系客服</div>
        <div @click="hideServeDialog" class="dialog-head-close"></div>
      </div>
      <div class="dialog-body padding">
        <div class="wechat-customer-block">
          <el-image class="wechat-customer-qrcode" :src="qrcode"></el-image>
          <div class="wechat-customer-title">
            存储空间不足，请联系客服升级版本
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :show-close="false"
      :visible.sync="showServiceSubscriptionGuideDialog"
      width="500px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="dialog-head">
        <div class="dialog-head-title">联系客户经理</div>
        <div
          @click="showServiceSubscriptionGuideDialog = false"
          class="dialog-head-close"
        ></div>
      </div>
      <div class="dialog-body padding">
        <div class="wechat-customer-block">
          <el-image
            class="wechat-customer-qrcode2"
            :src="serviceSubscriptionGuideImage"
          ></el-image>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>
<script setup>
// import Sidebar from "@/views/layout/Sidebar/index.vue";
import LeftMenu from "@/views/layout/left-menu.vue";
import Navbar from "@/views/layout/Navbar.vue";
import NetworkComponent from "./network.vue";
</script>
<script>
// import { mapGetters } from "vuex";
import Navbar from "@/views/layout/Navbar.vue";
</script>
<script>
import { mapGetters, mapState } from "vuex";
import { getChannelFee } from "@/api/teaching";
import { verifyToken } from "@/api/login";

const NEW_FEATURE_GUIDE_STORAGE_KEY =
  "dy_teacher_center_new_feature_guide_closed_date";

function getTodayDateString() {
  const now = new Date();
  const year = now.getFullYear();
  const month = `${now.getMonth() + 1}`.padStart(2, "0");
  const day = `${now.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export default {
  data() {
    return {
      showBall: false,
      helpExpend: false,
      helpWindow: false,
      helpAnim: false,
      helpSearch: false,
      helpKeyword: "",
      user: null,
      fixed: false,
      showNewFeatureGuide: true,
      routerArr: [
        {
          name: "创建星球",
          desc: "创建一个星球<br/>作为你的付费会员载体",
          route: "去创建",
          routePath: "/p/planet/editPlanet",
        },
        {
          name: "绑定微信群",
          desc: "把微信群绑定到星球中<br/>在成员购买星球后一键加群<br/>实现会员转入私域",
          route: "去绑定",
          routePath: "/p/planet/wxGroup",
        },
        {
          name: "渠道上架",
          desc: "将星球商品一键上架到抖音/视频号<br/>小红书/微信/网页等进行售卖推广",
          route: "去上架",
          routePath: "/p/planet/list",
        },
        {
          name: "会员运营",
          desc: "持续为会员提供专属内容/课程<br/>直播/答疑/打卡/作业/资料<br/>等长期价值",
          route: "去运营",
          routePath: "/p/planet/list?id=1",
        },
        {
          name: "收益提现",
          desc: "定期核对收益<br/>完成收益结算和提现",
          route: "去提现",
          routePath: "/p/accounting/balance",
        },
      ],
      showGuideDialog: false,
      showDemoDialog: false,
      currentGuideIndex: 1,
      currentDemoIndex: 1,
      showServeDialog: false,
      showServiceSubscriptionGuideDialog: false,
      qrcode:
        "https://image.renrenjiang.cn/teacher_center/website/icon_home_customer_qrcode.jpg?t=1",
      serviceSubscriptionGuideImage:
        "https://cdn-hz.renrenjiang.cn/home/success-qrcode.jpg",
      tokenVerifyPromise: null,
    };
  },
  computed: {
    // ...mapGetters({ drawer: "drawer", uploads: "uploads" }),
    ...mapGetters({ drawer: "drawer", uploads: "uploads" }),
    ...mapState("uploads", ["isLimit"]),
    // 获取uploads模块中的isLimit状态
    // newUploads() {
    //   return this.uploads.filter((item) => item.status < 2);
    // },
    convertRateZheng1() {
      if (this.convertData.clickJoinedBtnCount === 0) {
        return 0;
      }
      return Math.floor(
        (
          this.convertData.clickJoinedBtnCount /
          this.convertData.viewBeforeHomePageCount
        ).toFixed(4) * 100
      );
    },
    convertRateZheng2() {
      if (this.convertData.joinedSuccessCount === 0) {
        return 0;
      }
      return Math.floor(
        (
          this.convertData.joinedSuccessCount /
          this.convertData.clickJoinedBtnCount
        ).toFixed(4) * 100
      );
    },
    convertRateZheng3() {
      if (this.convertData.joinedSuccessCount === 0) {
        return 0;
      }
      return Math.floor(
        (
          this.convertData.joinedSuccessCount /
          this.convertData.viewBeforeHomePageCount
        ).toFixed(4) * 100
      );
    },
    convertRateYu1() {
      if (this.convertData.clickJoinedBtnCount === 0) {
        return 0;
      }
      return (
        (
          this.convertData.viewBeforeHomePageCount /
          this.convertData.clickJoinedBtnCount
        ).toFixed(4) *
          100 -
        this.convertRateZheng1 * 100
      );
    },
    convertRateYu2() {
      if (this.convertData.joinedSuccessCount === 0) {
        return 0;
      }
      return Math.floor(
        (
          this.convertData.clickJoinedBtnCount /
          this.convertData.joinedSuccessCount
        ).toFixed(4) *
          100 -
          this.convertRateZheng2 * 100
      );
    },
    convertRateYu3() {
      if (this.convertData.joinedSuccessCount === 0) {
        return 0;
      }
      return Math.floor(
        (
          this.convertData.viewBeforeHomePageCount /
          this.convertData.joinedSuccessCount
        ).toFixed(4) *
          100 -
          this.convertRateZheng3 * 100
      );
    },
    guideImgPath() {
      return `https://image.renrenjiang.cn/jy_star/icons/guide${this.currentGuideIndex}.png?t=9`;
    },
    demoImgPath() {
      return `https://image.renrenjiang.cn/jy_star/icons/demo${this.currentDemoIndex}.png?t=3`;
    },
    guideBtnText() {
      return this.currentGuideIndex === 5
        ? "开始体验"
        : `下一步 ${this.currentGuideIndex}/5`;
    },
    demoBtnText() {
      return this.currentDemoIndex === 8
        ? "我知道了"
        : `下一步 ${this.currentDemoIndex}/8`;
    },
  },
  // 监听isLimit状态变化
  watch: {
    isLimit(newVal) {
      console.log("newVal", newVal);
      if (newVal) {
        this.showServeDialog = true;
      }
    },
    "$route.fullPath"() {
      this.checkTokenOnRouteChange();
    },
  },
  async mounted() {
    this.showBall = false;
    this.user = this.$rrj.storage.get("_ukit");
    this.showNewFeatureGuide =
      window.localStorage.getItem(NEW_FEATURE_GUIDE_STORAGE_KEY) !==
      getTodayDateString();
    if (this.user.id === 21217432) {
      // setTimeout(() => {
      //   this.helpAnim = true;
      //   setTimeout(() => {
      //     this.helpExpend = true;
      //   }, 2000);
      // }, 2000);
    }

    let res = await getChannelFee();
    if (res.result === "ok") {
      if (res.data.tt_channel !== 1) {
        this.qrcode =
          "https://image.renrenjiang.cn/images/2025/server_3074.png";
      }
    }

    // console.log("this.user", this.user);

    this.$bus.$on("clickShowGuide", () => {
      this.showGuideDialog = true;
      this.currentGuideIndex = 1;
      this.currentDemoIndex = 1;
    });

    this.checkTokenValidity({ silent: true });
  },
  methods: {
    async checkTokenOnRouteChange() {
      if (!this.$rrj.storage.get("_token")) {
        return;
      }
      await this.checkTokenValidity({ silent: false });
    },
    async checkTokenValidity({ silent = false } = {}) {
      const token = this.$rrj.storage.get("_token");
      if (!token || !token.id) {
        return;
      }
      if (this.tokenVerifyPromise) {
        return this.tokenVerifyPromise;
      }
      this.tokenVerifyPromise = verifyToken(token.id)
        .then((res) => {
          if (res && res.result === "ok" && res.tokenValid !== false) {
            return true;
          }
          throw new Error((res && (res.message || res.msg)) || "token已失效");
        })
        .catch(async (error) => {
          const errorMessage =
            (error && error.message) || "登录状态已失效，请重新登录";
          await this.handleTokenInvalid({ silent, message: errorMessage });
          return false;
        })
        .finally(() => {
          this.tokenVerifyPromise = null;
        });
      return this.tokenVerifyPromise;
    },
    async handleTokenInvalid({ silent = false, message = "" } = {}) {
      await this.$store.dispatch("LogOut");
      if (!silent) {
        this.$message.error(message || "登录状态已失效，请重新登录");
      }
      const loginPath =
        this.$route && this.$route.path && this.$route.path.indexOf("/p/") === 0
          ? "/p/login"
          : "/login";
      if (this.$route.path !== loginPath) {
        this.$router.replace(loginPath);
      }
    },
    handleOpenServiceSubscriptionGuide() {
      this.showServiceSubscriptionGuideDialog = true;
      if (this.$route.path === "/setting/serviceSubscription") {
        return;
      }
      this.$router.push("/setting/serviceSubscription");
    },
    handleCloseNewFeatureGuide() {
      this.showNewFeatureGuide = false;
      window.localStorage.setItem(
        NEW_FEATURE_GUIDE_STORAGE_KEY,
        getTodayDateString()
      );
    },
    hideServeDialog() {
      this.showServeDialog = false;
      this.$store.commit("uploads/setUploadLimit", false);
    },
    closeDemoDialog() {
      this.showDemoDialog = false;
      setTimeout(() => {
        this.showGuideDialog = true;
      }, 300);
    },
    showDemo(index) {
      this.currentDemoIndex = index;
    },
    showGuide(index) {
      this.currentGuideIndex = index;
    },
    addStep() {
      this.currentGuideIndex++;
      if (this.currentGuideIndex === 6) {
        this.showGuideDialog = false;
        // 没有星球时 弹出新建星球
        this.$bus.$emit("showCreatePlanetGuide");
      }
    },
    addStepDemo() {
      this.currentDemoIndex++;
      if (this.currentDemoIndex === 9) {
        this.showDemoDialog = false;
        setTimeout(() => {
          this.showGuideDialog = true;
        }, 300);
      }
    },
    fixFn(e) {
      this.fixed = e;
    },
    openCustomerWindow() {
      this.helpExpend = false;
      this.helpWindow = true;
    },
    closeCustomerWindow() {
      this.helpWindow = false;
    },
    closeCustomerExpend() {
      this.helpExpend = false;
    },
    closeDrawer() {
      this.$store.dispatch("TOGGLEDRAWER").then(() => {});
    },
    deleteUpload(activityId) {
      this.$confirm("是否删除该上传任务?", "提示", {
        type: "warning",
      })
        .then(() => {
          for (let i = 0; i < this.uploads.length; i++) {
            if (this.uploads[i].activity.id === activityId) {
              this.$store.dispatch("deleteUpload", {
                activityId,
                upload: this.uploads[i],
              });
            }
          }
        })
        .catch((err) => {
          /* eslint-disable */
          console.log(err);
          /* eslint-enable */
          this.$message("取消操作");
        });
    },
    retryUpload(activityId) {
      setTimeout(() => {
        this.loading = false;
      }, 2000);
      for (let i = 0; i <= this.uploads.length; i++) {
        if (this.uploads[i].activity.id === activityId) {
          this.$store.dispatch("retryUpload", activityId);
        }
      }
    },
    restartUpload(activityId) {
      this.$store.dispatch("restartUpload", activityId);
    },
    pageToHome() {
      this.$router.push("/website");
    },
  },
};
</script>
<style lang="scss">
.layout {
  height: 100%;
  background-color: #f7f8fa;
  // height: 0;
  // flex-grow: 1;
  // display: flex;
  // align-items: flex-start;

  .wrapper-logo {
    position: sticky;
    top: 0;
    z-index: 10;
    padding: 20px 27px 31px 29px;
    // width: 142px;
    // height: 22px;
    background-color: #09244f;
    img {
      width: 142px;
    }
    cursor: pointer;
  }

  .asside {
    // position: absolute;
    //background-color: #09244f;
    height: 100%;
    transition: all 0.1s;
  }

  .asside::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
  }

  .layout-content {
    // width: calc(100vw - 200px);
    // width
    flex: 1;
    overflow-x: scroll;

    .container {
      background-color: #f7f8fa;
      // padding-left: 20px;
      min-width: 1240px;
      height: 100%;
    }

    .header {
      height: 70px;
      background-color: #fff;
      box-shadow: 0px 4px 10px 0px rgba(85, 56, 56, 0.1);
      z-index: 10;
    }

    .main {
      padding: 16px;
      position: relative;
    }
  }

  .right-layout {
    transform: scale(0, 0);
    width: 0px;
    background-color: #105cfb;
    transition: width 0.5s;
  }

  .right-layout-active {
    width: 300px;
    transform: scale(1, 1);
  }
}

.layout-body {
  height: 0;
}

.process-ball {
  position: fixed;
  right: 15px;
  bottom: 20px;
  width: 170px;
  height: 54px;
  img {
    width: 152px;
    height: 54px;
  }
}

@keyframes processAnimation {
  from {
    width: 300px;
    height: 200px;
  }
  to {
    width: 500px;
    height: 500px;
  }
}

.process-dialog {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 300px;
  height: 200px;
  // animation: processAnimation 0.3s ease-out;
  box-shadow: 0px 2px 6px 0px rgba(131, 154, 246, 0.302);

  .dialog-body {
    height: 100%;
  }

  .process-line {
    display: flex;
    justify-content: space-between;
  }
}

.process-dialog-active {
  width: 500px;
  height: 500px;
  animation: processAnimation 0.3s ease-in;
}

.float-customer {
  position: fixed;
  bottom: 80px;
  right: 20px;
  z-index: 100;
  width: 100px;

  display: flex;
  flex-direction: column;
  align-items: center;

  transition: all 0.3s;

  &.hidden {
    transform: translateX(130px);
  }

  &.anim {
    .float-customer-ip {
      animation: customerAnim 0.6s 3;
    }
  }

  &.expend {
    width: 160px;

    .float-customer-ip {
      transform: translateY(20px);
    }

    .float-customer-btn {
      width: 160px;
      height: 44px;
      line-height: 44px;
      border-radius: 0 0 12px 12px;
    }

    .float-customer-questions {
      height: 368px;
    }
  }

  .float-customer-ip {
    width: 60px;
    height: 60px;
    background-size: 100% 100%;
    background-image: url(https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_ip.png);
    transform: translateY(6px);
    z-index: 200;
  }

  .float-customer-questions {
    position: relative;
    width: 100%;
    height: 0;
    display: flex;
    overflow: hidden;
    align-items: center;
    flex-direction: column;
    border-radius: 12px 12px 0 0;
    background-image: linear-gradient(
      180deg,
      #0366ff 0%,
      rgba($color: #0366ff, $alpha: 0.2) 30%,
      #ffffff 110%
    );
    transition: all 0.3s;

    .float-customer-close {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 24px;
      height: 24px;
      background-size: 20px 20px;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_close.png);
      border-radius: 6px;
      cursor: pointer;

      &:hover {
        background-color: rgba($color: #ffffff, $alpha: 0.2);
      }
    }

    .question-block {
      width: 160px;
      height: 368px;

      box-sizing: border-box;
      padding-top: 16px;

      display: flex;
      flex-direction: column;
      align-items: center;

      .question-title {
        margin-bottom: 4px;
        margin-top: 11px;

        text-align: center;
        font-weight: 500;
        line-height: 20px;
        font-size: 14px;
        color: #ffffff;
      }

      .question-subtitle {
        width: 140px;
        height: 16px;
        text-align: center;
        line-height: 16px;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .question-list {
        width: 152px;
        flex-grow: 1;
        margin-top: 8px;
        border-radius: 8px 8px 0 0;
        background-color: #ffffff;
        box-sizing: border-box;
        padding: 8px 0;

        .question-item {
          word-wrap: break-word;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          color: #090909;
          cursor: pointer;
          display: -webkit-box;
          font-size: 12px;
          line-height: 18px;
          overflow: hidden;
          padding: 4px 12px;
          box-sizing: border-box;
          word-break: break-all;

          &:hover {
            color: #0366ff;
          }
        }
      }
    }
  }

  .float-customer-btn {
    width: 100px;
    height: 30px;
    z-index: 100;
    border-radius: 15px;
    background-image: linear-gradient(180deg, #3f96ff 0%, #3661fd 81%);

    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.3s;
  }
}

@keyframes customerAnim {
  0% {
    transform: translateY(6px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(6px);
  }
}

.customer-window {
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 380px;
  height: 80%;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  z-index: 500;

  transition: all 0.3s;
  transform: translateX(410px);

  &.active {
    transform: translateX(0);
  }
  // filter: drop-shadow(0 4px 32px rgba(0, 0, 0, 0.12));

  .customer-window-close {
    position: absolute;
    top: 25px;
    right: 25px;
    width: 24px;
    height: 24px;
    background-size: 20px 20px;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_close.png);
    border-radius: 6px;
    cursor: pointer;

    &:hover {
      background-color: rgba($color: #ffffff, $alpha: 0.2);
    }
  }

  .customer-window-head {
    position: relative;
    width: 380px;
    height: 200px;
    background-size: 100% 100%;
    background-image: url(https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_win_bgimg.png);

    padding-top: 84px;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    flex-direction: column;

    .customer-window-search {
      width: 330px;
      height: 32px;
      border-radius: 16px;
      border: 1px solid rgba($color: #ffffff, $alpha: 0.8);
      background-color: rgba($color: #ffffff, $alpha: 0.8);

      display: flex;
      align-items: center;

      padding: 0 16px;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        border-color: #0366ff;
      }

      .search-icon {
        width: 24px;
        height: 24px;
      }

      .search-text {
        margin-left: 6px;
        line-height: 20px;
        font-size: 14px;
        color: #acacac;
      }
    }

    .customer-window-keywords {
      width: 330px;
      margin-top: 16px;

      display: flex;
      align-items: center;

      .keyword-item {
        padding: 0 5px;
        margin-right: 10px;
        border-radius: 4px;
        background-color: rgba($color: #ffffff, $alpha: 0.2);

        line-height: 20px;
        font-size: 12px;
        color: #ffffff;
        cursor: pointer;

        &:hover {
          background-color: rgba($color: #ffffff, $alpha: 0.25);
        }
      }
    }
  }

  .customer-window-body {
    position: absolute;
    top: 168px;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 20px 20px 0 0;
    background-color: #ffffff;

    padding: 25px;
    box-sizing: border-box;

    .window-body-title {
      line-height: 25px;
      font-weight: 500;
      font-size: 16px;
      color: #090909;

      display: flex;
      align-items: center;
      justify-content: space-between;

      .title-btn {
        display: inline-flex;
        align-items: center;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }

        .title-btn-text {
          font-weight: normal;
          font-size: 14px;
          color: #0366ff;
        }

        .title-btn-icon {
          margin-left: 6px;
          width: 16px;
          height: 16px;
        }
      }
    }

    .window-body-quicks {
      display: flex;
      flex-wrap: wrap;
      margin: 15px 0;

      .quick-item {
        width: 140px;
        height: 32px;
        padding: 0 10px;
        border-radius: 6px;
        margin-bottom: 10px;
        background-color: #f0f6ff;

        display: inline-flex;
        align-items: center;
        cursor: pointer;

        &:nth-child(2n) {
          margin-left: 10px;
        }

        .quick-item-icon {
          width: 20px;
          height: 20px;
        }

        .quick-item-text {
          margin-left: 10px;
          font-size: 14px;
          color: #090909;
        }
      }
    }

    .window-body-questions {
      margin: 15px 0;

      .question-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        cursor: pointer;

        &:hover {
          .question-item-content {
            color: #0366ff;
          }
        }

        .question-item-icon {
          width: 20px;
          height: 20px;
        }

        .question-item-content {
          width: 0;
          height: 20px;
          flex-grow: 1;

          line-height: 20px;
          font-size: 14px;
          color: #090909;

          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .question-item-arrow {
          margin-left: 20px;
          width: 20px;
          height: 20px;
        }
      }
    }
    // <div class="window-body-questions">
    //       <div class="question-item">
    //         <el-image
    //           class="question-item-icon"
    //           src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_qa_icon.png"
    //         ></el-image>
    //         <div class="question-item-content">
    //           【玩转搜索】如何做好商品的主图优化如何做好商品的主图优化？
    //         </div>
    //         <el-image
    //           class="question-item-arrow"
    //           src="https://image.renrenjiang.cn/teacher_center/douyin/icon_preview_arrow.png"
    //         ></el-image>
  }

  .customer-window-ip {
    position: absolute;
    top: 20px;
    left: 25px;

    display: flex;
    align-items: center;

    .window-ip-img {
      width: 50px;
      height: 48px;
      filter: drop-shadow(0 0 6px rgba(3, 102, 255, 0.42));
    }

    .window-ip-text {
      margin-left: 16px;
      line-height: 22px;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
    }
  }

  .customer-window-search-block {
    position: absolute;
    top: 58px;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 20px 20px 0 0;
    background-color: #ffffff;
    transition: all 0.3s;
    transform: translateY(100%);
    opacity: 0;

    &.active {
      transform: translateY(0);
      opacity: 1;
    }

    .search-block {
      .search-block-head {
        padding: 16px;
        box-sizing: border-box;

        display: flex;
        align-items: center;

        .search-block-input {
          border-radius: 16px;

          .el-input__inner {
            border-radius: 16px;
          }

          .input-search-icon {
            width: 20px;
            height: 32px;
          }
        }

        .search-block-btn {
          width: 28px;
          color: #686767;
          cursor: pointer;
          font-size: 12px;
          margin-left: 8px;
        }
      }

      .search-block-body {
        padding: 16px;
        box-sizing: border-box;

        .search-block-title {
          align-items: center;
          display: flex;
          justify-content: space-between;
          padding-bottom: 16px;

          .title-text {
            color: #acacac;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
          }
        }

        .search-block-hots {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;

          width: 330px;
          height: 140px;

          .hot-item {
            width: 50%;
            height: 20px;
            margin-bottom: 14px;

            display: inline-flex;
            align-items: center;

            .hot-item-num {
              align-items: center;
              background: #dadbe0;
              border-radius: 4px;
              color: #ffffff;
              display: inline-flex;
              justify-content: center;
              flex-shrink: 0;
              font-size: 12px;
              font-weight: 600;
              height: 16px;
              width: 16px;
            }

            &:nth-child(1) {
              .hot-item-num {
                background: linear-gradient(
                  317.73deg,
                  #ffa800 -1.64%,
                  #ffc700 97.02%
                );
              }
            }

            &:nth-child(2) {
              .hot-item-num {
                background: linear-gradient(315deg, #9eaae3, #bfc9f9);
              }
            }

            &:nth-child(3) {
              .hot-item-num {
                background: linear-gradient(315deg, #e6a06e, #f0ad7d);
              }
            }

            .hot-item-text {
              color: #090909;
              flex: 1;
              font-size: 12px;
              margin-left: 8px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  .customer-window-floating {
    position: absolute;
    bottom: 0;
    right: 12px;
    bottom: 100px;

    width: 48px;
    height: 48px;
    border-radius: 24px;
    box-shadow: 0px 4px 10px 0px rgba(0, 43, 143, 0.3);
    background-image: linear-gradient(149deg, #159eff 16%, #0366ff 86%);

    padding: 0 12px;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      width: 150px;
    }

    .floating-block {
      width: 92px;
      height: 48px;
      display: flex;
      align-items: center;

      .floating-icon {
        width: 24px;
        height: 24px;
      }

      .floating-text {
        white-space: nowrap;
        margin-left: 12px;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }
}

.guide-wrapper {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1271px;
  height: 743px;
  box-sizing: border-box;
  background: #fff
    url("https://image.renrenjiang.cn/jy_star/icons/guide-bg.png?t=1") left top /
    cover no-repeat;
  border-radius: 39px;
  .guide-left {
    width: 391px;
    height: 743px;
    flex: none;
    .title {
      margin-bottom: 50px;
      padding-top: 70px;
      padding-left: 55px;
      color: #3d3d3d;
      font-size: 28px;
      font-weight: 600;
    }
    .demo-title {
      margin-bottom: 30px;
    }
    .item {
      position: relative;
      margin-bottom: 10px;
      width: 391px;
      height: 90px;
      padding-left: 55px;
      padding-right: 55px;
      border-radius: 20px;
      box-sizing: border-box;
      cursor: pointer;
      .item-icon {
        display: none;
      }
      .item-title {
        padding-top: 10px;
        padding-bottom: 5px;
        font-size: 20px;
        font-weight: 500;
        color: #3d3d3d;
      }
      .demo-item-title {
        padding-top: 0;
        padding-bottom: 0;
        line-height: 65px;
      }
      .item-desc {
        font-size: 16px;
        font-weight: normal;
        color: #b0b0b6;
        font-family: PingFang SC;
        font-size: 16px;
        font-weight: normal;
        line-height: 20px;
      }
    }
    .demo-item {
      height: 65px;
    }
    .active {
      animation: moveLeft 1s forwards;
      transition: 1px left;
      box-shadow: 6px 5px 10px -2px rgba(1, 81, 205, 0.37);
      background-color: #0366ff;
      .item-title,
      .item-desc {
        color: #fff;
      }
      .item-icon {
        position: absolute;
        display: block;
        width: 20px;
        height: 24px;
        top: 30px;
        left: 15px;
      }
      .demo-icon {
        top: 21px;
      }
    }
    @keyframes moveLeft {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-55px);
      }
    }
  }
  .guide-right {
    margin-right: 40px;
    flex: none;
    width: 822px;
    height: 716px;
    overflow: hidden;
    border-radius: 20px;
    .guide-image {
      width: 822px;
      //height: 716px;
    }
    .guide-image-margin {
      margin-top: 25px;
    }
  }
  .guide-btn {
    position: absolute;
    right: -30px;
    top: -74px;
    width: 300px;
    height: 54px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    .step-btn {
      width: 176px;
      height: 54px;
      color: #fff;
      font-size: 20px;
      line-height: 54px;
      text-align: center;
      border-radius: 54px;
      background-color: #0366ff;
      cursor: pointer;
    }
    .close-btn {
      font-size: 54px;
      color: rgba(255, 255, 255, 0.52);
      cursor: pointer;
    }
  }
}

.wechat-customer-block {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 20px;

  .wechat-customer-qrcode {
    width: 350px;
    height: 350px;
  }

  .wechat-customer-qrcode2 {
    width: 450px;
    height: 450px;
    border-radius: 12px;
  }

  .wechat-customer-title {
    color: #090909;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-top: 16px;
  }
}

.new-feature-guide {
  width: 230px;
  background-color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.08);
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(17, 24, 39, 0.12);
  }

  .guide-title {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-actions {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .title-text {
      font-weight: 600;
      font-size: 16px;
      color: #0366ff;
    }

    .title-tag {
      height: 20px;
      padding: 0 8px;
      border-radius: 10px;
      background-color: #ff4444;
      line-height: 20px;
      font-size: 12px;
      color: #ffffff;
    }

    .guide-close {
      width: 24px;
      height: 24px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #909399;
      background-color: #f5f7fa;
      transition: all 0.2s ease;

      &:hover {
        color: #0366ff;
        background-color: #ecf5ff;
      }
    }
  }

  .guide-item {
    width: 210px;
    margin-bottom: 12px;
    cursor: pointer;

    &:nth-child(3) {
      .guide-item-cover {
        border: 2px solid #eae4fd;
      }
    }

    .guide-item-cover {
      width: 100%;
      border-radius: 8px;
      border: 2px solid #dae7fd;
    }
  }

  .guide-gap {
    height: 0;
    flex-grow: 1;
  }

  .guide-contact {
    width: calc(100% - 20px);
    padding: 10px;
    margin: 12px 0;
    border-radius: 8px;
    box-sizing: border-box;
    background-color: #ffffff;
    box-shadow: 0 0 44px rgba(3, 102, 255, 0.16);

    display: flex;
    align-items: center;
    flex-direction: column;

    .guide-contact-title {
      font-weight: 600;
      font-size: 14px;
      color: #1e2226;

      &.align-right {
        text-align: right;
      }
    }

    .guide-contact-key {
      margin: 6px 0;
      font-weight: 600;
      font-size: 15px;
      color: #0366ff;
    }

    .guide-contact-btn {
      margin-top: 12px;
    }
  }
}
</style>
